<div
  class="input-container"
  [ngClass]="inputContainerClass"
  [class.input-container--error]="hasError"
  [class.input-container--with-right-button]="!!rightButtonIconType"
>
  <vtmn-play-icon
    *ngIf="inputIconType"
    [name]="inputIconType"
    class="input-container__icon"
  ></vtmn-play-icon>
  <input
    class="input-container__input"
    [attr.id]="id"
    [attr.aria-describedby]="errorsId"
    [attr.max]="max"
    [attr.min]="min"
    [attr.aria-label]="ariaLabel"
    [disabled]="disabled || freeActivity"
    [name]="name"
    [pattern]="pattern"
    [attr.placeholder]="placeholder"
    [attr.tabindex]="tabindex"
    [type]="type"
    [readonly]="readonly"
    [required]="required"
    [(ngModel)]="value"
    (blur)="touched()"
    (keydown.enter)="keyDownEnter($event)"
    (focus)="focusInput.emit()"
    data-test="input"
  />
  <button
    app-vtmn-play-icon-button
    *ngIf="rightButtonIconType"
    type="button"
    class="input-container__right-button"
    [type]="ctaButtonTypeButton"
    [size]="vtmnPlayIconButtonSize.SMALL"
    [variant]="vtmnPlayIconButtonVariant.TERTIARY"
    [disabled]="disabled ? true : null"
    [attr.data-disabled]="disabled ? true : null"
    (click)="rightButtonClick.emit()"
  >
    <vtmn-play-icon
      [name]="rightButtonIconType"
      [ariaLabel]="rightButtonAriaLabel"
    ></vtmn-play-icon>
  </button>
</div>
